import React from 'react';
import { NumericFormatProps } from 'react-number-format/types/types';
import { IntRangeString } from '@payer-admin-ui/components-v2/src/functions/numbers';
import { ExtendedNumberFormat } from './ExtendedNumberFormat';

export type PercentFormatProps = {
  percent: number;
  fractionDigits?: IntRangeString;
  nullable?: boolean;
} & Omit<NumericFormatProps, 'fractionDigits' | 'value' | 'suffix' | 'nullable'>;

export const PercentFormat = ({ percent, fractionDigits = '0..', nullable = false, ...props }: PercentFormatProps) => (
  <ExtendedNumberFormat {...props} fractionDigits={fractionDigits} value={percent} suffix=" %" nullable={nullable} />
);
